export const waitForSignalDocumentationMarkdown = `
## Wait for Signal

The Wait for Signal block pauses flow execution and waits for an external signal with a specified name. The block resumes when the signal is received or when the configured timeout period elapses, whichever comes first. This enables workflows to pause and wait for external events, such as form completions, API callbacks, or manual interventions, before proceeding.

**Note:** If you are waiting for a signal from a form set, the form set must be configured within this same flow for the Wait for Signal block to work correctly. We'd recommend using the Wait for Form Completion block instead.

**This block is a developer only block and should not be used in production flows.**
`;
